import {
  Component,
  DestroyRef,
  inject,
  input,
  ViewContainerRef
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AbstractControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MomentModule } from 'ngx-moment';
import { ToastrService } from 'ngx-toastr';
import { filter, take } from 'rxjs';
import { Product } from 'src/app/models';
import { BarcodeScannerDialogComponent } from '../../barcode-scanner-dialog/dialog/dialog.component';
import { BookingItemNamePipe } from '../../pipes/booking-item-name.pipe';
import { ConfigService } from '../../services/config.service';
import { ItemService } from '../../services/item.service';
import { RetailProductService } from '../../services/retail-product.service';
import { SearchService } from '../../services/search.service';

@Component({
  selector: 'tr[mobile-assign-items-table-row]',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    BookingItemNamePipe,
    MomentModule,
    MatButtonModule,
    MatIcon
  ],
  template: `
    <td
      class="flex flex-col justify-start items-stretch"
      [formGroup]="formRow()"
    >
      <p>
        {{ formRow().value.bookingItem | bookingItemName }}
      </p>
      @if (
        formRow().value.bookingItem.item &&
        formRow().value.bookingItem.item.notes
      ) {
        <p>
          <small
            ><strong>Item details:</strong>
            {{ formRow().value.bookingItem.item.notes }}</small
          >
        </p>
      }
      <p>
        <small
          ><strong>Notes:</strong>
          {{ formRow().value.bookingItem.notes }}</small
        >
      </p>
      <div class="flex flex-row justify-start items-center w-full">
        <mat-form-field class="basis-full flex-grow">
          <mat-label>
            Select item for {{ formRow().value.bookingItem | bookingItemName }}
          </mat-label>
          <mat-select required formControlName="item">
            @for (product of productItems(); track product.id) {
              <mat-optgroup [label]="product.name">
                @for (item of product.items; track item.id) {
                  <mat-option
                    [value]="item"
                    [disabled]="
                      item.status !== 'Available' ||
                      item.has_current_workshop_jobs
                    "
                  >
                    {{ item.code }}
                    @if (item.notes) {
                      <span> - {{ item.notes }}</span>
                    }
                  </mat-option>
                }
              </mat-optgroup>
            }
          </mat-select>
          @if (itemControl().hasError('unavailable')) {
            <mat-error>{{ itemControl().errors['unavailable'] }} </mat-error>
          }
          @if (itemControl().hasError('duplicate')) {
            <mat-error>{{ itemControl().errors['duplicate'] }} </mat-error>
          }
          @if (itemControl().hasError('required')) {
            <mat-error>You must specify an item to continue </mat-error>
          }
        </mat-form-field>

        <button
          mat-icon-button
          (click)="openScanner()"
          class="flex-grow-0 flex-shrink-0 basis-auto"
        >
          <mat-icon>barcode_reader</mat-icon>
        </button>
      </div>
    </td>
  `,
  styles: `
    :host {
      display: table-row;
    }
  `,
  providers: [SearchService, RetailProductService, ToastrService, ItemService]
})
export class MobileAssignItemsTableRowComponent {
  index = input.required<number>();
  formRow = input.required<any>();
  itemControl = input.required<AbstractControl>();
  dateTimeFormat = ConfigService.dates.longDateTimeFormat;
  productItems = input.required<Product[]>();
  vcr = inject(ViewContainerRef);
  dialog = inject(MatDialog);
  destroyRef = inject(DestroyRef);

  openScanner() {
    this.dialog
      .open(BarcodeScannerDialogComponent, {
        viewContainerRef: this.vcr
      })
      .afterClosed()
      .pipe(take(1), takeUntilDestroyed(this.destroyRef), filter(Boolean))
      .subscribe((result) => {
        console.log({ result });
        this.formRow().controls.item.patchValue(result.resource);
      });
  }
}
